import type { TripSegment } from '../types'

export interface SegmentFilters {
	date_range?: string
	keyword?: string
	order_status?: string
	shipper_ids?: string
	consignee_ids?: string
	is_active?: string
	limit?: number
}

export async function fetchSegments(
	token: string,
	apiURL: string,
	filters?: SegmentFilters
): Promise<TripSegment[]> {
	const url = new URL(`${apiURL}/api/segments`)
	url.searchParams.set('token', token)

	// Add all filter parameters if provided
	if (filters) {
		if (filters.date_range) url.searchParams.set('date_range', filters.date_range)
		if (filters.keyword) url.searchParams.set('keyword', filters.keyword)
		if (filters.order_status) url.searchParams.set('order_status', filters.order_status)
		if (filters.shipper_ids) url.searchParams.set('shipper_ids', filters.shipper_ids)
		if (filters.consignee_ids) url.searchParams.set('consignee_ids', filters.consignee_ids)
		if (filters.is_active) url.searchParams.set('is_active', filters.is_active)
		if (filters.limit) url.searchParams.set('limit', filters.limit.toString())
	}

	const res = await fetch(url)
	if (!res.ok) throw new Error(`API error: ${res.status}`)

	return res.json()
}

export async function fetchPings(
	token: string,
	apiURL: string,
	tripId: string
): Promise<Array<{ lat: number; lng: number; ts: string }>> {
	const url = new URL(`${apiURL}/api/pings/${tripId}`)
	url.searchParams.set('token', token)

	const res = await fetch(url)
	if (!res.ok) throw new Error(`API error: ${res.status}`)

	return res.json()
}

export async function snapRoute(
	token: string,
	apiURL: string,
	tripId: string
): Promise<{ snapped_geojson: GeoJSON.LineString | GeoJSON.MultiLineString | GeoJSON.Point }> {
	const url = new URL(`${apiURL}/api/segments/${tripId}/snap`)
	url.searchParams.set('token', token)

	const res = await fetch(url, { method: 'POST' })
	if (!res.ok) throw new Error(`API error: ${res.status}`)

	return res.json()
}
